import { graphql } from 'gatsby';
import { StyledLogo, StyledLinkTitle, StyledLink, StyledImage } from './FooterLogo.styles';
import useLinkProps from '@/components/Link/hooks/useLinkProps';

const FOOTER_LOGO_WIDTH = 160;
const FOOTER_LOGO_HEIGHT = 40;

const FooterLogo = ({ footerLogoElements: elements }: Queries.FOOTER_LOGOFragment) => {
  const {
    link: {
      value: { linkElements },
    },
    logo,
  } = elements;
  const { linkChildren, linkProps } = useLinkProps({
    action: linkElements.action.value,
    target: linkElements.target?.value,
    event: linkElements.event?.value,
  });

  return (
    <StyledLogo>
      <StyledLink {...linkProps}>
        {linkChildren}
        <StyledLinkTitle>{linkElements.text.value}</StyledLinkTitle>
        <StyledImage
          alt={logo.value.description ?? ''}
          height={FOOTER_LOGO_HEIGHT}
          image={{
            ...logo.value,
            height: FOOTER_LOGO_HEIGHT,
            image_id: logo.value.name,
            width: FOOTER_LOGO_WIDTH,
          }}
          objectFit="contain"
          width={FOOTER_LOGO_WIDTH}
        />
      </StyledLink>
    </StyledLogo>
  );
};

export default FooterLogo;

export const fragment = graphql`
  fragment FOOTER_LOGO on kontent_item_footer_logo {
    footerLogoElements: elements {
      logo {
        value {
          description
          height
          name
          type
          url
          width
        }
      }
      link {
        value {
          ...LINK
        }
      }
    }
  }
`;
